import { render } from "./CustomerLotDetailsView.vue?vue&type=template&id=2922c201&scoped=true&ts=true&lang=pug"
import script from "./CustomerLotDetailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerLotDetailsView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerLotDetailsView.vue?vue&type=style&index=0&id=2922c201&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2922c201"]])

export default __exports__